import { NavigationItem } from '@/components/ui/navigation';

export const navigationLearn = [
  { name: 'courses', href: '/learn' },
  { name: 'in progress', href: '/learn/in-progress' },
  { name: 'completed', href: '/learn/completed' },
  //   { name: 'search', href: '/learn/search' },
] as NavigationItem[];

export const navigationCourse = [
  { name: 'courses', href: '/learn', forceActive: true },
  { name: 'in progress', href: '/learn/in-progress' },
  { name: 'completed', href: '/learn/completed' },
  //   { name: 'search', href: '/learn/search' },
] as NavigationItem[];
